var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWordline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "124.69635627530364 157.89473684210526 564.3724696356276 55.06072874493927",
    style: {
      maxHeight: 500
    },
    width: 564.3724696356276,
    height: 55.06072874493927,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeWidth: 5,
    strokeLinecap: "round",
    stroke: "#58a0df",
    fill: "none",
    d: "m159.88 176.05c44.112 1.1976 177.64 9.1816 264.67 7.1856 87.026-1.996 258.08-21.357 257.49-19.162-0.59881 2.1956-169.06 27.944-261.08 32.335s-309.18-7.7844-291.02-5.988c18.164 1.7964 333.33 13.972 400 16.766"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordline);
export default __webpack_public_path__ + "static/media/wordline.07566ab886f66ab9e10a151b354feb9d.svg";
export { ForwardRef as ReactComponent };